<template>
	<div id="app">
		<router-view></router-view>
		<div class="page-component-up" v-show="is_scroll" @click="Top">
	  		<i class="el-icon-caret-top"></i>
	  	</div>
		<div class="main-footer">
			<!-- <ul class="main-footer-link">
				<li>吉贡成员企业</li>
				<li>
					<el-tooltip placement="top">
					  	<div slot="content">商务联系：021-23561292</div>
					  	<a href="http://www.jigon.cn/index.php?m=content&c=index&a=lists&catid=20">联系我们</a>
					</el-tooltip>
				</li>
				<li style="border: 0;"><a href="http://www.jigon.cn/index.php?m=content&c=index&a=lists&catid=15">关于吉贡</a></li>
			</ul> -->
			<!-- <div class="main-copyright">Copyright@2011-2016上海贡云信息技术有限公司版权所有Corporation All Rights Reserved 沪ICP备 16049652号-3</div> -->
      <div class="main-copyright"><a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="bank">{{icpInfo}}</a></div>
      <div class="main-copyright" v-if="policeInfo"><a href="http://www.beian.gov.cn/portal/registerSystemInfo" target="bank"><img style="width: 12px;margin-right: 6px;" src="./assets/img/police.png" alt="" srcset>{{policeInfo}}</a></div>
		</div>
	</div>
</template>

<script>
import { getRealmNameConfig } from "@/config/interface.js";
import { fetch } from "@/config/fetch.js";
  export default {
    name: 'app',
    data(){
    	return {
    		is_scroll: false,
        icpInfo: null,
        policeInfo: null,
    	}
    },
    created(){
      this.getWebInfo();
    },
    mounted(){
    	window.addEventListener('scroll', this.showTop);
    },
    methods: {
      getWebInfo(){
        let url = getRealmNameConfig;
        let _this = this;
        let params = {
          // loginUrl: window.location.host.indexOf('localhost') != -1  ? 'small.test.359chain.com' : window.location.host,
          loginUrl: window.location.host.indexOf('localhost') != -1  ? 'small.359chain.com' : window.location.host,
        };
        fetch(url, params).then(res => {
          if (res.code == 10000) {

            this.icpInfo = res.data.icpInfo;
            this.policeInfo = res.data.policeInfo;

            let logoUrl = res.data.webLogo;
            this.$store.dispatch("setLogoUrl", logoUrl);

            let backPicture = res.data.backPictureUrl;
            this.$store.dispatch("setBackPicture", backPicture);

            let headerName = res.data.hearderName;
            this.$store.dispatch('setHeaderName',headerName);

            let bodyId = res.data.bodyId;
            this.$store.dispatch('setBodyId',bodyId);
            (function () {
              document.title = res.data.webName;
              let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
              link.type = 'image/x-icon';
              link.rel = 'shortcut icon';
              link.href = res.data.webBrowserLogo;
              document.getElementsByTagName('head')[0].appendChild(link);
            })();
          }
        });
      },
    	showTop(){
  		  var scrollTop = document.documentElement.scrollTop;
    		if(scrollTop > 300){
    			this.is_scroll = true;
    		}else{
    			this.is_scroll = false;
    		}
    	},
    	Top(){
    		document.documentElement.scrollTop = 0;
    	}
    }
  }
</script>



// WEBPACK FOOTER //
// App.vue?b9c01d76